import {useState, useEffect} from "react";

export default function ConfirmButton({onConfirm, className, children, confirmLabel = "Confirm?"}) {
    const [confirming, setConfirming] = useState(false);

    useEffect(() => {
        if (!confirming) return;
        const t = setTimeout(() => setConfirming(false), 3000);
        return () => clearTimeout(t);
    }, [confirming]);

    if (confirming) return (
        <span className="d-inline-flex gap-1" onClick={e => e.stopPropagation()}>
            <button
                className="btn btn-sm btn-danger"
                onClick={() => { setConfirming(false); onConfirm(); }}
            >
                Yes
            </button>
            <button
                className="btn btn-sm btn-outline-secondary"
                onClick={() => setConfirming(false)}
            >
                <i className="bi bi-x" />
            </button>
        </span>
    );

    return (
        <button className={className} onClick={e => { e.stopPropagation(); setConfirming(true); }}>
            {children}
        </button>
    );
}
